import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate, Link, useLocation  } from 'react-router-dom';
import Footer from './Footer.js';
import { Spinner } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const EditStockReports = () => {
  const [users, setUsers] = useState([]);
  
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [user, setUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [genderFilter, setGenderFilter] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [areas, setAreas] = useState([]); // State to store dress types
  const [dressTypes, setDressTypes] = useState([]); // State to store dress types
  const [dressSizes, setDressSizes] = useState([]); // State to store dress types
  const [dressColors, setDressColors] = useState([]); // State to store dress types
  const navigate = useNavigate();
  const location = useLocation();
const searchParams = new URLSearchParams(location.search);

const areaId = searchParams.get('area_id');
const gender = searchParams.get('gender');
const dressType = searchParams.get('dress_type');
const dressSize = searchParams.get('dress_size');
const dressColor = searchParams.get('dress_color');
const quantity = searchParams.get('quantity');
const gnrNumber = searchParams.get('gnr_number');

  const handleAddStock = () => {
    navigate('/add_stock');
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data && data.profile && typeof data.profile.is_uniform_access_given !== 'undefined') {
          setUser(data.profile.is_uniform_access_given);
        } else {
          setUser(null); // or 'N' if you want default non-admin
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const token = localStorage.getItem('authToken');

        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}areas`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch areas');
        }

        const data = await response.json();

        if (data && Array.isArray(data.areas)) {
          const activeAreas = data.areas.filter(area => area.status === 'A');
          setAreas(activeAreas);
        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAreas();
  }, []);

  useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched dress types:', data);

        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          // Filter out dress types with status 'A'
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes); // Set active dress types
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched data:', data);
        if (data && data.dressSizes && Array.isArray(data.dressSizes)) {
          // Filter out users with status 'A'
          const activeDressSizes = data.dressSizes.filter(user => user.status === 'A');
          setDressSizes(activeDressSizes);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched data:', data);

        if (data && data.dressColors && Array.isArray(data.dressColors)) {
          // Filter out users with status 'A'
          const activeDressColors = data.dressColors.filter(user => user.status === 'A');
          setDressColors(activeDressColors);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts

  // Function to get the dress type name by ID
  const getAreaName = (id) => {
    const area = areas.find(a => a.id == id); // Use == in case types mismatch (string vs number)
    return area ? area.area : 'Unknown';
  };

  // Function to get the dress type name by ID
  const getDressTypeName = (id) => {
    const dressType = dressTypes.find(type => type.id === id);
    return dressType ? dressType.dress_type : 'Unknown';
  };

  // Function to get the dress type name by ID
  const getDressSizeName = (id) => {
    const dressSize = dressSizes.find(type => type.id === id);
    return dressSize ? dressSize.dress_size : 'Unknown';
  };

  // Function to get the dress type name by ID
  const getDressColorName = (id) => {
    const dressColor = dressColors.find(type => type.id === id);
    return dressColor ? dressColor.dress_color : 'Unknown';
  };

 useEffect(() => {
  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      const payload = {
        area_id: areaId,
        gender: gender,
        dress_type: dressType,
        dress_size: dressSize,
        dress_color: dressColor,
        quantity: quantity,
        gnr_number: gnrNumber
      };

      const response = await fetch(`${BASE_URL}stocks_details`, {
        method: 'POST', // ✅ Must be POST to send a body
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data && data.stockdetails && Array.isArray(data.stockdetails)) {
        setUsers(data.stockdetails);
        setFilteredUsers(data.stockdetails);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchUsers();
}, [areaId, gender, dressType, dressSize, dressColor, quantity, gnrNumber]);

  const handleSearch = (e) => {
  setSearchQuery(e.target.value.toLowerCase());
};

useEffect(() => {
  let filteredData = [...users];

  // Gender filter
  if (genderFilter) {
    filteredData = filteredData.filter(user => user.gender === genderFilter);
  }

  // From Date filter
  if (fromDate) {
    filteredData = filteredData.filter(user =>
      new Date(user.created_at) >= new Date(fromDate)
    );
  }

  // To Date filter
  if (toDate) {
    filteredData = filteredData.filter(user =>
      new Date(user.created_at) <= new Date(toDate)
    );
  }

  // Search query filter
  if (searchQuery) {
    filteredData = filteredData.filter(user =>
      getAreaName(user.area_id).toLowerCase().includes(searchQuery) ||
      getDressTypeName(user.dress_type).toLowerCase().includes(searchQuery) ||
      getDressSizeName(user.dress_size).toLowerCase().includes(searchQuery) ||
      getDressColorName(user.dress_color).toLowerCase().includes(searchQuery) ||
      user.gnr_number.toLowerCase().includes(searchQuery)
    );
  }

  setFilteredUsers(filteredData);
}, [searchQuery, genderFilter, fromDate, toDate, users]);



  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page on change of items per page
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);



  if (loading) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }


  const exportToExcel = () => {
    const dataToExport = users.map((item, index) => ({
      "S/N": indexOfFirstItem + index + 1,
      "gender" :item.gender,
      "area" : getAreaName(item.area_id),
      "Dress Type": getDressTypeName(item.dress_type),
      "Size": getDressSizeName(item.dress_size),
      "Color": getDressColorName(item.dress_color),
      "Quantity": item.quantity,
      "Created At": item.created_at
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Data");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, 'stock_data.xlsx');
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  return (
    <>
      <div className="page-wrapper">
        <HeaderMobile />
        <Sidebar isOpen={isSidebarOpen} />
        <div className="page-container" style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
          transition: 'margin-left 0.3s ease',

        }}>
          <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
          <div className="main-content">
            <div className="section__content section__content--p30">
              <div className="container-fluid">
                <div className="mb-3 text-right">
                  <button className="btn btn-success" onClick={exportToExcel}>
                    Export to Excel
                  </button>
                </div>
                
                <div className="row">

                  <div className="col-lg-12">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      

                      {/* Search and Rows Per Page Selector in Same Row */}
                      <div className="d-flex align-items-center flex-wrap">
  {/* Search Input */}
  <div className="me-3 mb-2">
    <input
      type="text"
      className="form-control"
      placeholder="Search Dress Type"
      value={searchQuery}
      onChange={handleSearch}
    />
  </div>

  {/* Rows Per Page */}
  <div className="me-3 mb-2 d-flex align-items-center">
    <label htmlFor="rowsPerPage" className="form-label me-2">Rows:</label>
    <select
      id="rowsPerPage"
      className="form-control"
      style={{ width: 'auto' }}
      value={itemsPerPage}
      onChange={handleItemsPerPageChange}
    >
      <option value={10}>10</option>
      <option value={20}>20</option>
      <option value={30}>30</option>
    </select>
  </div>

  {/* Gender Filter */}
  <div className="mb-2">
    <select
      className="form-control"
      value={genderFilter}
      onChange={e => setGenderFilter(e.target.value)}
    >
      <option value="">All Genders</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
    </select>
  </div>
  <div className="mb-2">
    <input
      type="date"
      className="form-control"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  {/* To Date */}
  <div className="mb-2">
    <input
      type="date"
      className="form-control"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>
</div>

                    </div>

                    <div className="table-responsive table--no-card m-b-30">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Gender</th>
                            <th>Area</th>
                            <th>Dress Type</th>
                            <th>Size</th>
                            <th>Color</th>
                            <th>Quantity</th>
                            
                            <th>Created At</th>
                        
                          </tr>
                        </thead>
                        <tbody>
                          {currentUsers.length > 0 ? (
                            currentUsers.map((item, index) => (
                              <tr key={item.id}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{item.gender}</td>
                                <td>{getAreaName(item.area_id)}</td>
                                <td>{getDressTypeName(item.dress_type)}</td>
                                <td>{getDressSizeName(item.dress_size)}</td>
                                <td>{getDressColorName(item.dress_color)}</td>

                                <td>{item.quantity}</td>
                               

                                <td>{item.created_at}</td>
                               
                              </tr>
                            ))
                          ) : (
                            <tr><td colSpan="6" className="text-center">No stock data found</td></tr>
                          )}
                        </tbody>
                      </table>

                    </div>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="btn btn-sm btn-outline-secondary mx-1"
                      >
                        Prev
                      </button>

                      {[...Array(totalPages).keys()].map(pageNumber => (
                        <button
                          key={pageNumber}
                          onClick={() => paginate(pageNumber + 1)}
                          className={`btn btn-sm ${currentPage === pageNumber + 1 ? 'btn-primary' : 'btn-outline-secondary'} mx-1`}
                        >
                          {pageNumber + 1}
                        </button>
                      ))}

                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="btn btn-sm btn-outline-secondary mx-1"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default EditStockReports;
